// Module
var code = "<contacts-sidebar> </contacts-sidebar> <ui-view> <contacts-list></contacts-list> </ui-view> ";
// Exports
module.exports = code;